import React from 'react';
import Translate from '../shared/localization/localize';
import * as DT from '../../modules/datatable';
import * as Orders from '../../modules/orders';

export const getColumns = () => {
  const columnDefinitions: DT.TableColumn[] = [
    {
      Header: <Translate message={Orders.msgOrder} />,
      id: 'orderNumber',
      accessor: 'orderNumber',
      customizable: false,
      defaultShow: true,
    },
    {
      Header: <Translate message={Orders.msgNumDevices} />,
      id: 'numDevices',
      accessor: 'numDevices',
      customizable: true,
      defaultShow: true,
    },
    {
      Header: <Translate message={Orders.msgInvoiceDate} />,
      id: 'invoiceDate',
      accessor: (o: Orders.Order) =>
        new Date(o.invoiceDate).toLocaleDateString(),
      customizable: true,
      defaultShow: true,
    },
  ];

  return DT.initColumnsVisibility(columnDefinitions);
};

export default getColumns;
